/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import TokenModal from "./TokenDialog";
import SlippageSettings from "./SlippageSettings";
import { IoSettings } from "react-icons/io5";
import { useParams, useNavigate } from "react-router-dom";
import {
    getErc20Contract,
    getFactoryContract,
    getRouterContract,
    getWalletBalanceContract,
} from "../contexts/thirdWebClient";
import { allowance, balanceOf } from "thirdweb/extensions/erc20";
import { routerAddress, WETHAddress } from "../contexts/config";
import {
    useActiveAccount,
    useActiveWalletChain,
} from "thirdweb/react";
import { prepareContractCall, readContract, sendTransaction as sendTx } from "thirdweb";
import { toast } from "react-toastify";
import { ethers } from "ethers";
import { getCurrencyMetadata } from "thirdweb/extensions/erc20";

const AddLiquidity = () => {
    const [open, setOpen] = useState(false);
    const [openBuy, setOpenBuy] = useState(false);
    const [selected, setSelected] = useState({});
    const [selectedBuy, setSelectedBuy] = useState({});
    const [loading, setLoading] = useState(false);
    const [balanceLoading, setBalanceLoading] = useState(false);
    const [checkData, setCheckData] = useState(false);
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [slippage, setSlippage] = useState(() => {
        const saved = localStorage.getItem("dexora_slippage");
        return saved ? parseFloat(saved) : 1;
    });

    const add = useActiveAccount();
    const [address, setAddress] = useState("");
    const chain = useActiveWalletChain();
    useEffect(() => {
        if (add && add.address) {
            console.log("%c Line:41 🍅 add", "color:#7f2b82", add);
            setAddress(add.address);
        }
    }, [add, chain]);
    let navigate = useNavigate();
    const { address1, address2 } = useParams();

    useEffect(() => {
        const fetchData = async () => {
            if (address1) {
                const tokenData = await tokenDetails(address1);
                setSelected(tokenData);
            }
            if (address2) {
                const tokenData = await tokenDetails(address2);
                setSelectedBuy(tokenData);
            }
            setCheckData(true);
        };
        fetchData();
    }, [address1, address2, add, chain]); // eslint-disable-line react-hooks/exhaustive-deps

    const [token1Details, setToken1Details] = useState({});
    const [token2Details, setToken2Details] = useState({});

    const [token1value, setToken1value] = useState(0);
    const [token2value, setToken2value] = useState(0);

    const [price, setPrice] = useState(1);

    const isValidAddress = (addr) => /^0x[a-fA-F0-9]{40}$/.test(addr);

    const tokenDetails = async (value) => {
        try {
            if (value && isValidAddress(value) && chain && chain?.id) {
                const contract = getErc20Contract(value, chain);
                let currencyMetadata = await getCurrencyMetadata({ contract });
                currencyMetadata.address = value;
                return currencyMetadata;
            } else {
                return false;
            }
        } catch (error) {
            console.log("%c Line:85 🍎 tokenDetails error", "color:#6ec1c2", error);
            return false;
        }
    };

    useEffect(() => {
        if (checkData) {
            let route = `/pool/addliquidity/`;
            if (selected && selected !== "" && selected.address !== address1) {
                route += selected.address + "/";
            } else {
                route += address1 + "/";
            }
            if (
                selectedBuy &&
                selectedBuy !== "" &&
                selectedBuy.address !== address2
            ) {
                route += selectedBuy.address;
            } else {
                route += address2;
            }
            navigate(route);
        }
    }, [selected, selectedBuy]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const getData = async () => {
            setBalanceLoading(true);
            if (
                selected &&
                selected !== "" &&
                selected?.address &&
                address &&
                selected?.address !=
                    "0x0000000000000000000000000000000000000000"
            ) {
                const contract = getErc20Contract(selected.address, chain);
                let approvedAmount = await allowance({
                    contract,
                    owner: address,
                    spender: routerAddress,
                });
                let tokenBalance = await balanceOf({
                    contract,
                    address: address,
                });
                setToken1Details({
                    ...selected,
                    approvedBalance: Number(approvedAmount) * 1,
                    balance: Number(ethers.formatUnits(tokenBalance, selected?.decimals)) * 1,
                });
            }
            if (
                selected &&
                selected !== "" &&
                selected?.address ==
                    "0x0000000000000000000000000000000000000000"
            ) {
                let tokenBalance = await getWalletBalanceContract(
                    address,
                    chain,
                );
                setToken1Details({
                    ...selected,
                    approvedBalance: Number(100000000000) * 1,
                    balance: Number(ethers.formatUnits(tokenBalance, 18)) * 1,
                });
            }
            if (
                selectedBuy &&
                selectedBuy !== "" &&
                selectedBuy?.address &&
                selectedBuy?.address !=
                    "0x0000000000000000000000000000000000000000" &&
                address
            ) {
                const contract = getErc20Contract(selectedBuy.address, chain);
                let approvedAmount = await allowance({
                    contract,
                    owner: address,
                    spender: routerAddress,
                });
                let tokenBalance = await balanceOf({
                    contract,
                    address: address,
                });
                setToken2Details({
                    ...selectedBuy,
                    approvedBalance: Number(approvedAmount) * 1,
                    balance: Number(ethers.formatUnits(tokenBalance, selectedBuy?.decimals)) * 1,
                });
            }
            if (
                selectedBuy &&
                selectedBuy !== "" &&
                selectedBuy?.address ==
                    "0x0000000000000000000000000000000000000000"
            ) {
                let tokenBalance = await getWalletBalanceContract(
                    address,
                    chain,
                );
                setToken2Details({
                    ...selectedBuy,
                    approvedBalance: Number(100000000000) * 1,
                    balance: Number(ethers.formatUnits(tokenBalance, 18)) * 1,
                });
            }
            setBalanceLoading(false);
        };
        getData();
    }, [selected, selectedBuy, loading]); // eslint-disable-line react-hooks/exhaustive-deps

    const approveTokenFun = async (tokenAddress) => {
        try {
            setLoading(true);
            const contract = getErc20Contract(tokenAddress, chain);
            const transaction = prepareContractCall({
                contract,
                method: "function approve(address guy, uint256 wad) returns (bool)",
                params: [routerAddress, ethers.MaxUint256],
            });
            console.log(
                "%c Line:117 🍢 transaction",
                "color:#ed9ec7",
                transaction,
                add,
            );
            const tx = await sendTx({ transaction, account: add });
            console.log("%c Line:118 🥔 tx", "color:#93c0a4", tx);
            toast.success("Token approved");
            setLoading(false);
        } catch (error) {
            toast.error(error?.message);
            setLoading(false);

            console.log("%c Line:111 🍫 error", "color:#ed9ec7", error);
        }
    };



    // Calculate minimum amount with slippage
    const calculateMinAmount = (amount, decimals) => {
        try {
            const slippageMultiplier = (100 - slippage) / 100;
            const minAmount = parseFloat(amount) * slippageMultiplier;
            return ethers.parseUnits(minAmount.toFixed(decimals), decimals);
        } catch (error) {
            console.log("Error calculating min amount:", error);
            return "1"; // Fallback
        }
    };

    const addLiquidity = async () => {
        try {
            setLoading(true);
            const contract = getRouterContract(chain);

            let token1amount = ethers.parseUnits(
                token1value,
                token1Details?.decimals,
            );

            let token2amount = ethers.parseUnits(
                token2value,
                token2Details?.decimals,
            );

            let transaction;
            if (
                token1Details?.address ==
                    "0x0000000000000000000000000000000000000000" ||
                token2Details?.address ==
                    "0x0000000000000000000000000000000000000000"
            ) {
                transaction = prepareContractCall({
                    contract,
                    method: "function addLiquidityETH(address token, uint256 amountTokenDesired, uint256 amountTokenMin, uint256 amountETHMin, address to, uint256 deadline) payable returns (uint256 amountToken, uint256 amountETH, uint256 liquidity)",
                    params: [
                        token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                            ? token2Details?.address
                            : token1Details?.address,
                        token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                            ? token2amount
                            : token1amount,
                        calculateMinAmount(token1Details?.address == "0x0000000000000000000000000000000000000000" ? token2value : token1value, token1Details?.address == "0x0000000000000000000000000000000000000000" ? token2Details?.decimals : token1Details?.decimals),
                        calculateMinAmount(token1Details?.address == "0x0000000000000000000000000000000000000000" ? token1value : token2value, token1Details?.address == "0x0000000000000000000000000000000000000000" ? token1Details?.decimals : token2Details?.decimals),
                        address,
                        Math.floor(new Date().getTime() / 1000) + 900,
                    ],
                    value:
                        token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                            ? token1amount
                            : token2amount,
                });
            } else {
                transaction = prepareContractCall({
                    contract,
                    method: `function addLiquidity(address tokenA, address tokenB, uint256 amountADesired,uint256 amountBDesired,uint256 amountAMin,uint256 amountBMin,address to,uint256 deadline)`,
                    params: [
                        token1Details?.address,
                        token2Details?.address,
                        token1amount,
                        token2amount,
                        calculateMinAmount(token1value, token1Details?.decimals),
                        calculateMinAmount(token2value, token2Details?.decimals),
                        address,
                        Math.floor(new Date().getTime() / 1000) + 900,
                    ],
                });
            }
            const txData = await sendTx({ transaction, account: add });
            console.log("%c Line:173 🥐 txData", "color:#3f7cff", txData);
            toast.success("Liquidity Added");

            // Reset input values after successful liquidity addition
            setToken1value(0);
            setToken2value(0);

            setLoading(false);

            // Redirect to pool page with refresh state
            navigate('/pool', { state: { refresh: true } });
        } catch (error) {
            toast.error(error?.message);
            setLoading(false);
            console.log("%c Line:166 🍕 error", "color:#f5ce50", error);
        }
    };

    useEffect(() => {
        if (token1Details.address && token2Details.address) {
            fetchLpDetails();
        }
    });

    const [lpAddress, setLpAddress] = useState(false);
    const [token1LpBalance, setToken1LpBalance] = useState(0);
    const [token2LpBalance, setToken2LpBalance] = useState(0);

    const fetchLpDetails = async () => {
        try {
            const routerContract = await getRouterContract(chain);
            const factoryContract = await getFactoryContract(chain);

            let pairAddress = await readContract({
                contract: factoryContract,
                method: "function getPair(address, address) view returns (address)",
                params: [
                    token1Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token1Details?.address,
                    token2Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token2Details?.address,
                ],
            });

            if(pairAddress != "0x0000000000000000000000000000000000000000"){
                setLpAddress(true);
                console.log(
                    "%c Line:224 🍧 pairAddress",
                    "color:#7f2b82",
                    pairAddress,
                );
    
                const Token0contract = getErc20Contract(
                    token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token1Details?.address,
                    chain,
                );
                let tokenOUserBalance = await balanceOf({
                    contract: Token0contract,
                    address: pairAddress,
                });
                setToken1LpBalance(tokenOUserBalance);
    
                const Token1contract = getErc20Contract(
                    token2Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token2Details?.address,
                    chain,
                );
    
                let token1UserBalance = await balanceOf({
                    contract: Token1contract,
                    address: pairAddress,
                });
                setToken2LpBalance(token1UserBalance);
    
                let tokenPrice = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        ethers.parseUnits("1", selected?.decimals),
                        tokenOUserBalance,
                        token1UserBalance,
                    ],
                });
    
                setPrice(
                    Number(
                        ethers.formatUnits(tokenPrice, selectedBuy?.decimals),
                    ).toFixed(5),
                );
            }else {
                setPrice(0)
            }
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const fetchPriceDetails = async (value) => {
        try {
            // Clear token2 value if input is empty or invalid
            if (!value || value === '' || parseFloat(value) <= 0) {
                setToken2value(0);
                return;
            }

            if(lpAddress && token1LpBalance > 0 && token2LpBalance > 0){
                const routerContract = await getRouterContract(chain);

                let token0Price = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        ethers.parseUnits(value, selected?.decimals),
                        token1LpBalance,
                        token2LpBalance,
                    ],
                });

                setToken2value(
                    Number(
                        ethers.formatUnits(token0Price, selectedBuy?.decimals),
                    ).toFixed(5),
                );
            }
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const fetchPrice2Details = async (value) => {
        try {
            // Clear token1 value if input is empty or invalid
            if (!value || value === '' || parseFloat(value) <= 0) {
                setToken1value(0);
                return;
            }

            if(lpAddress && token1LpBalance > 0 && token2LpBalance > 0){
                const routerContract = await getRouterContract(chain);

                let token0Price = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        ethers.parseUnits(value, selectedBuy?.decimals),
                        token2LpBalance,
                        token1LpBalance,
                    ],
                });
                setToken1value(
                    Number(
                        ethers.formatUnits(token0Price, selected?.decimals),
                    ).toFixed(5),
                );
            }
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    return (
        <div className="w-full max-w-[480px] flex flex-col card-3d p-6">
            {/* Card Header */}
            <div className="flex items-center justify-between mb-5">
                <h2 className="text-[22px] font-bold gradient-text">Add Liquidity</h2>
                <button
                    className="w-9 h-9 rounded-xl flex items-center justify-center swap-arrow-3d"
                    onClick={() => setSettingsOpen(true)}
                    title="Slippage Settings"
                >
                    <IoSettings className="text-dexora-text-secondary size-[18px]" />
                </button>
            </div>

            {/* Token 1 Section */}
            <div className="inner-3d p-4 mb-1">
                <div className="flex justify-between items-center mb-3">
                    <span className="text-[12px] font-semibold text-dexora-text-muted uppercase tracking-widest">Token 1</span>
                    {address && token1Details && token1Details?.symbol && (
                        <span className="text-[12px] text-dexora-text-muted">
                            Bal: <span className="text-dexora-cyan font-semibold">
                                {balanceLoading ? (
                                    <span className="animate-pulse">...</span>
                                ) : (
                                    token1Details?.balance ? token1Details.balance.toFixed(4) : '0.0000'
                                )}
                            </span>
                        </span>
                    )}
                </div>
                <div className="flex items-center justify-between gap-3">
                    <input
                        className="text-[28px] sm:text-[32px] font-bold text-dexora-text-primary bg-transparent outline-none w-full placeholder:text-dexora-text-muted/30"
                        type="number"
                        min="0"
                        step="any"
                        value={token1value === 0 || token1value === '' ? '' : token1value}
                        placeholder="0.00"
                        onChange={(e) => {
                            setToken1value(e.target.value);
                            fetchPriceDetails(e.target.value);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                e.preventDefault();
                            }
                        }}
                    />
                    <div
                        onClick={() => setOpen(!open)}
                        className="token-pill-3d flex items-center gap-2 px-3 py-2 cursor-pointer shrink-0"
                    >
                        {selected && selected?.symbol ? (
                            <>
                                {selected?.img && (
                                    <img src={selected.img} alt={selected.symbol} className="size-[24px] rounded-full ring-1 ring-white/10" />
                                )}
                                <span className="font-bold text-[15px] text-dexora-text-primary whitespace-nowrap">{selected?.symbol}</span>
                            </>
                        ) : (
                            <span className="font-semibold text-[13px] text-dexora-cyan whitespace-nowrap">Select</span>
                        )}
                        <svg className="w-3.5 h-3.5 text-dexora-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" /></svg>
                    </div>
                </div>
            </div>

            {/* Plus Icon */}
            <div className="flex justify-center -my-5 z-10">
                <div className="swap-arrow-3d w-11 h-11 flex items-center justify-center">
                    <svg className="w-5 h-5 text-dexora-text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" /></svg>
                </div>
            </div>

            {/* Token 2 Section */}
            <div className="inner-3d p-4 mt-1">
                <div className="flex justify-between items-center mb-3">
                    <span className="text-[12px] font-semibold text-dexora-text-muted uppercase tracking-widest">Token 2</span>
                    {address && token2Details && token2Details?.symbol && (
                        <span className="text-[12px] text-dexora-text-muted">
                            Bal: <span className="text-dexora-cyan font-semibold">
                                {balanceLoading ? (
                                    <span className="animate-pulse">...</span>
                                ) : (
                                    token2Details?.balance ? token2Details.balance.toFixed(4) : '0.0000'
                                )}
                            </span>
                        </span>
                    )}
                </div>
                <div className="flex items-center justify-between gap-3">
                    <input
                        className="text-[28px] sm:text-[32px] font-bold text-dexora-text-primary bg-transparent outline-none w-full placeholder:text-dexora-text-muted/30"
                        type="number"
                        min="0"
                        step="any"
                        value={token2value === 0 || token2value === '' ? '' : token2value}
                        placeholder="0.00"
                        onChange={(e) => {
                            setToken2value(e.target.value);
                            fetchPrice2Details(e.target.value);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                e.preventDefault();
                            }
                        }}
                    />
                    <div
                        onClick={() => setOpenBuy(!openBuy)}
                        className="token-pill-3d flex items-center gap-2 px-3 py-2 cursor-pointer shrink-0"
                    >
                        {selectedBuy && selectedBuy?.symbol ? (
                            <>
                                {selectedBuy?.img && (
                                    <img src={selectedBuy.img} alt={selectedBuy.symbol} className="size-[24px] rounded-full ring-1 ring-white/10" />
                                )}
                                <span className="font-bold text-[15px] text-dexora-text-primary whitespace-nowrap">{selectedBuy?.symbol}</span>
                            </>
                        ) : (
                            <span className="font-semibold text-[13px] text-dexora-cyan whitespace-nowrap">Select</span>
                        )}
                        <svg className="w-3.5 h-3.5 text-dexora-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" /></svg>
                    </div>
                </div>
            </div>

            {/* Price Info */}
            <div className="flex items-center px-1 py-2 mt-2">
                <div className="w-1.5 h-1.5 rounded-full bg-dexora-cyan/50 mr-2"></div>
                <span className="text-[12px] text-dexora-text-muted font-medium">
                    {lpAddress
                        ? <>1 {token1Details.symbol} = {price} {token2Details?.symbol}</>
                        : <>{token1value} {token1Details.symbol} = {token2value} {token2Details?.symbol}</>
                    }
                </span>
            </div>

            {/* Approve / Add Liquidity Buttons */}
            {token1Details && token1Details?.symbol && token1Details?.approvedBalance <= 0 ? (
                <button
                    className={`mt-3 w-full py-4 text-[16px] font-bold btn-3d ${loading ? "text-dexora-text-muted" : "text-dexora-dark"}`}
                    disabled={loading}
                    onClick={() => !loading && approveTokenFun(token1Details?.address)}
                >
                    {loading ? "APPROVING..." : `APPROVE ${token1Details?.symbol?.toUpperCase()}`}
                </button>
            ) : (
                ""
            )}
            {token2Details && token2Details?.symbol && token2Details?.approvedBalance <= 0 ? (
                <button
                    className={`mt-3 w-full py-4 text-[16px] font-bold btn-3d ${loading ? "text-dexora-text-muted" : "text-dexora-dark"}`}
                    disabled={loading}
                    onClick={() => !loading && approveTokenFun(token2Details?.address)}
                >
                    {loading ? "APPROVING..." : `APPROVE ${token2Details?.symbol?.toUpperCase()}`}
                </button>
            ) : (
                ""
            )}
            {token1Details?.approvedBalance > 0 && token2Details?.approvedBalance > 0 && (
                <button
                    className={`mt-4 w-full py-4 text-[16px] font-bold btn-3d ${
                        loading || !selected?.symbol || !selectedBuy?.symbol || !token1value || !token2value || token1value <= 0 || token2value <= 0 || parseFloat(token1value) > token1Details?.balance || parseFloat(token2value) > token2Details?.balance
                            ? "text-dexora-text-muted"
                            : "text-dexora-dark"
                    }`}
                    disabled={loading || !selected?.symbol || !selectedBuy?.symbol || !token1value || !token2value || token1value <= 0 || token2value <= 0}
                    onClick={addLiquidity}
                >
                    {loading ? "ADDING..." : parseFloat(token1value) > token1Details?.balance ? `INSUFFICIENT ${token1Details?.symbol} BALANCE` : parseFloat(token2value) > token2Details?.balance ? `INSUFFICIENT ${token2Details?.symbol} BALANCE` : "ADD LIQUIDITY"}
                </button>
            )}

            <TokenModal open={open} setOpen={setOpen} onClick={setSelected} />
            <TokenModal open={openBuy} setOpen={setOpenBuy} onClick={setSelectedBuy} />
            <SlippageSettings open={settingsOpen} setOpen={setSettingsOpen} slippage={slippage} setSlippage={setSlippage} />
        </div>
    );
};

export default AddLiquidity;
